import { Component, HostListener, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ClientaccountService } from 'src/app/services/apiclient/clientaccount/clientaccount.service';
import { catchError, forkJoin, from, of, switchMap } from 'rxjs';
import { ClientOrdersService } from 'src/app/services/apiclient/order/clientorders.service';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { Router } from "@angular/router";
import { Touchterminalpayment } from 'src/app/services/api/touchterminalpayment/touchterminalpayment.service';
import { NewBarcodeComponent } from 'src/app/services/barcode/barcode.component';
import { OrderEncoderService } from 'src/app/services/success-order-encoder.service';
import { OrderInterface, ClientAccount, PaymentType, SaleMethod, StripeCharge, OrderLevel } from './success-order.interface.component';
// import { ClientAccount, OrderInterface, OrderLevel } from 'src/app/models/api/orders.api.types';
// import { PaymentType, StripeCharge } from 'src/app/models/api/payments.api.types';
// import { SaleMethod } from 'src/app/models/api/pos.api.types';

/*
Cette page affiche la confirmation d'une commande réussie.
Elle gère l'affichage des détails de commande, les différents moyens de paiement, et l'impression automatique en mode borne.
*/

@Component({
  selector: 'app-success-order',
  templateUrl: './success-order.component.html',
  styleUrls: ['./success-order.component.css']
})
export class SuccessOrderComponent implements OnInit, OnDestroy {
  @ViewChild(NewBarcodeComponent) newBarcodeComponent!: NewBarcodeComponent;

  order: OrderInterface | null = null;        // Contient toutes les données de la commande validée
  client: ClientAccount | null = null;        // Informations du client
  typeOfPayment: PaymentType = '';           // Type de paiement utilisé (card, counter, paypal, etc.)
  loader = true;                              // Affiche/cache le loader pendant le chargement des données
  currdevicePrintAuto: string | null = null;  // Configuration d'impression automatique du dispositif
  currdevice: string | null = null;           // ID du dispositif (borne/terminal)
  statusMessage = '';                         // Message affiché dans le loader
  interval: ReturnType<typeof setInterval> | null = null;  // Référence de l'intervalle pour le timer de redirection
  timeSec = 30;                               // Temps restant avant redirection automatique (mode borne)
  resetTimeSec = 30;                          // Valeur de reset du timer
  modeBorne = false;                          // Indique si on est en mode borne/kiosque
  currSm: SaleMethod | null = null;           // Méthode de vente (SaleMethod) actuelle.
  //
  barCodeValue = '';
  barcodeUrl = '';
  basket: any;
  order_level: any;
  latestOrderComment = '';
  currentOrderLevelName = '';
  currentOrderLevelColor: string | undefined;
  uberTrackingUrl: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private orderApi: ClientOrdersService,
    private clientApi: ClientaccountService,
    public tools: ToolsService,
    public router: Router,
    private Touchterminalpayment: Touchterminalpayment,
    private orderEncoderService: OrderEncoderService,
  ) { }

  @HostListener('window:touchstart')
  ontouchstart() {
    if (this.modeBorne && this.timeSec < 30) {
      this.timeSec = this.resetTimeSec;
    }
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  ngOnInit() {
    this.modeBorne = this.tools.getStor('devicePaybridge') ? true : false;
    this.tools.setExpirity();
    this.statusMessage = "successOrder.statusMessage";
    const orderId = this.route.snapshot.paramMap.get('orderId');
    // console.log('success-order.component - orderIdEncoded :', orderId);
    this.route.params.pipe(
      //je gere le décodage de orderId et de l'url Uber si existante

      switchMap((params: any) => from(this.orderEncoderService.decryptOrderId(params.orderId))),
      switchMap((decoded: { orderId: number; uberTrackingUrl?: string | null }) => {
        // ici on injecte l'URL pour le bouton
        this.uberTrackingUrl = decoded.uberTrackingUrl ?? null;

        return forkJoin({
          order: this.orderApi.getOrder(decoded.orderId),
          client: this.clientApi.getClientAccount(),
          orderId: of(decoded.orderId),
        });
      }),
      // Gestion d'erreur
      catchError((error) => {
        console.error('Erreur:', error);
        this.loader = false;
        this.router.navigate(['/']);
        throw error;
      })
    ).subscribe(({ order, client }) => {
      if (order) {
        this.order = order;
        // console.log("fulle-success-order.component - ngOnInit - this.order : ", this.order);

        this.barCodeValue = `FW-${order.reference}`;
        this.basket = this.order?.basket;
      }
      if (client) {
        this.client = client;
      }
      this.setTypeOfPayment(order);
      this.checkBorne();
      this.loader = false;
      this.refreshOrderLevel();
    });
  }

  setTypeOfPayment(order: OrderInterface) {
    if (order && order.order_payments.length > 0) {

      if (order.order_payments.length === 1 && order.order_payments[0].id_payment_mean === -15) {
        this.typeOfPayment = "cagnotte";
      } else {
        for (let i = 0; i < order.order_payments.length; i++) {
          const orderP = order.order_payments[i];

          // Stripe
          if (orderP.id_payment_mean === -42) {
            const parsedCharge: StripeCharge | null = order.id_stripe_charge ? JSON.parse(order.id_stripe_charge) : null;
            if (parsedCharge && parsedCharge.payment_method_details.type === "stripe" || !parsedCharge) {
              this.typeOfPayment = "stripe";
              break;
            } else if (parsedCharge.payment_method_details.type === "card") {
              this.typeOfPayment = orderP.captured === 1 ? "card" : "counter";
              break;
            }
            else if (parsedCharge.payment_method_details.type === "paypal") {
              this.typeOfPayment = 'paypal';
              break;
            }
          }

          // Paypal
          if (orderP.id_payment_mean === -43) {
            this.typeOfPayment = "paypal";
            break;
          }

          // Payzen
          if (orderP.id_payment_mean === -48) {
            this.typeOfPayment = "payzen";
            break;
          }

          if (orderP.id_payment_mean === -59) {
            this.typeOfPayment = "borne";
            break;
          }

          // Yavin
          if (orderP.id_payment_mean === -60) {
            this.typeOfPayment = "yavin";
            break;
          }

          // MyPos
          if (orderP.id_payment_mean === -61) {
            this.typeOfPayment = "mypos";
            break;
          }
        }
      }
    }
    else {
      this.typeOfPayment = "counter";
    }

    if (!this.modeBorne) {
      this.tools.removeStor("smId");
    }

    if (this.typeOfPayment !== "borne" && this.modeBorne) {
      this.timerRedirect();
    }
  }

  checkBorne() {
    this.currdevice = this.tools.getStor("devicePaybridge") ? this.tools.getStor("devicePaybridge") : null;
    this.currdevicePrintAuto = this.currdevice ? this.tools.getStor("devicePaybridgePrint") : null;
    if (this.currdevicePrintAuto) {
      this.print();
    }
  }

  print() {
    if (this.currdevicePrintAuto) {
      this.payIntentsetPrint();
    }
    else {
      window.print();
    }
  }

  timerRedirect() {
    this.interval = setInterval(() => {
      if (this.timeSec > 0) {
        this.timeSec -= 1;
      }
      if (this.timeSec == 0 && this.interval) {
        clearInterval(this.interval);
        this.interval = null;
        this.goProductPage();
      }
    }, 1000);
  }

  goPointOfSalePage() {
    this.router.navigate([], { queryParams: {} });
    this.tools.goPointOfSalePage();
  }

  goProductPage() {
    this.router.navigate([], { queryParams: {} });
    this.tools.goProductPage(this.order?.point_of_sale);
  }

  goHomeAccount() {
    this.tools.goHome_();
  }

  payIntentsetPrint() {
    const params = {
      id_webshop: this.order?.point_of_sale.id_webshop,
      amount: 0,
      id_device: this.currdevice,
      order_id: this.order?.id,
      print_type: 2,
    };

    this.Touchterminalpayment.setTouchTerminalPayIntent(params).subscribe(payintent => {
      if (payintent.code < 0)
        console.error('[PRINT] Error: ko')
      else {
        this.loader = true;
        this.statusMessage = "borne.print"
        setTimeout(() => {
          this.loader = false;
          this.timerRedirect();
        }, 5000);
      }
    })
  }

  // Refresh order level
  refreshOrderLevel() {
    // Vérifier que l'ordre est bien chargé
    if (!this.order?.id_user || !this.order?.id) {
      return;
    }
    this.orderApi.getOrderLevel(this.order.id_user, this.order.id)
      .then((data) => {
        if (!data) return;
        this.order_level = data;
        // On cherche le niveau correspondant à this.order.id_order_level dans la liste des order_levels du client (data)
        if (data.order_levels?.length > 0 && this.order?.id_order_level !== undefined) {
          const currentLevel: OrderLevel = data.order_levels.find(
            (level: any) => level.id === this.order!.id_order_level
          );
          if (currentLevel) {
            this.currentOrderLevelName = currentLevel.name;
            this.currentOrderLevelColor = currentLevel.color;
          } else {
            this.currentOrderLevelName = '';
            this.currentOrderLevelColor = '';
          }
        }
      })
      .catch((err) => {
        console.error('Erreur getOrderLevel:', err);
      });
  }

  openUberTracking(): void {
    if (!this.uberTrackingUrl) {
      return;
    }
    // console.log("fulle-success-order.component - openUberTracking - this.uberTrackingUrl : ", this.uberTrackingUrl);

    window.open(
      this.uberTrackingUrl,
      '_blank',
      'noopener,noreferrer'
    );
  }

}
